import {
  VISIT_ACTUAL_GET_REQUEST,
  VISIT_ACTUAL_GET_SUCCESS,
  VISIT_ACTUAL_GET_FAILURE,
  VISIT_ACTUAL_UPDATE_FAILURE,
  VISIT_ACTUAL_UPDATE_REQUEST,
  VISIT_ACTUAL_ERROR_DISMISS,
} from '../../../actions/constants/types';
import globals from '../../../globals/communityGlobals';

const locale = globals.getAreas(['visitActuals', 'error']);

const initialPreviewedState = {
  isFetching: false,
  visitActual: null,
};

function updateErrror(state, action) {
  const { translationKey, parameters } = action.message;

  return {
    ...state,
    isFetching: false,
    failureMessage: locale.getMsg(translationKey, parameters),
  };
}

function previewVisitActual(state = initialPreviewedState, action) {
  switch (action.type) {
    case VISIT_ACTUAL_GET_REQUEST:
      return {
        ...initialPreviewedState,
        failureMessage: '',
        isFetching: true,
      };
    case VISIT_ACTUAL_GET_SUCCESS:
      return {
        isFetching: false,
        visitActual: action.response.data.visit,
        patient: action.response.data.patient,
      };
    case VISIT_ACTUAL_GET_FAILURE:
      return {
        isFetching: false,
      };
    case VISIT_ACTUAL_UPDATE_FAILURE:
      return updateErrror(state, action);
    case VISIT_ACTUAL_UPDATE_REQUEST:
      return {
        ...state,
        failureMessage: '',
      };
    case VISIT_ACTUAL_ERROR_DISMISS:
      return {
        ...state,
        failureMessage: '',
      };
    default:
      return state;
  }
}

export default previewVisitActual;
